<template>
  <div class="page">
    <div class="content">
      <div class="topContent">
        <div class="back" @click="goBack">
          <img src="../assets/images/images/noticeBack.png" />
          <div>返回</div>
        </div>
        <div class="title">消息/通知</div>
        <div></div>
      </div>

      <div class="contentInfo">
        <div
          v-if="systemList[0]" @click="goSystemList"
          class="noticeList"
        >
          <div class="userHead">
            <img src="../assets/images/images/systemNotify.png" />
          </div>
          <div class="rightContent">
            <div class="noticeTitle">
              <div>{{systemList[0].title}}</div>
              <div></div>
            </div>
            <div class="noticeWord">{{systemList[0].content}}</div>
            <div></div>
          </div>
        </div>
        <div
          v-for="(item, index) in noticeList"
          :key="index"
          class="noticeList"
          @click="goMessage(item.recipient_id, item.sender_id)"
        >
          <div class="userHead">
            <img :src="item.recipient.avatar_url" />
          </div>
          <div class="rightContent">
            <div class="noticeTitle">
              <div>{{ item.recipient.nickname }}</div>
              <div>{{ item.format_date }}</div>
            </div>
            <div class="noticeWord">{{ item.content }}</div>
            <div></div>
          </div>
        </div>
        <div id="showMore">{{ notice }}</div>
      </div>
    </div>
  </div>
</template>
<script>
let me;
let showMore = false; //是否在可视化区域内
import { getData } from "../Interface/http.js";
import { postData } from "../Interface/http.js";
export default {
  name: "noticeList",
  data() {
    return {
      page: 1,
      userId: '',
      systemList: [], //系统消息列表
      noticeList: [], //消息列表
      notice: "加载中...",
    };
  },
  methods: {
    goBack() {//返回上一页
      me.$router.go(-1);
    },
    goSystemList() {
      this.$router.push({
        path: '/systemNotifyList'
      })
    },
    //获取系统消息列表
    getSystemMessage() {
      getData(`/user/notifies?userId=${this.userId}&page=1`).then(res => {
        if(res.code == 0) {
          this.systemList = res.data;
        }
      })
    },
    //获取消息列表
    getNoticeList() {
      getData(
        "user/letter/list",
        {
          page: me.page,
        },
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      ).then((res) => {
        if (res.code == 0) {
           me.noticeList = me.noticeList.concat(res.data);
          //me.noticeList = res.data;
        }
        if (showMore && res.data.length != 0) {
          //在可视区域内，并且还有数据
          me.page = me.page + 1;
          // me.getNoticeList();
        }
        if (res.data.length < 10) {
          me.notice = "没有更多了";
        }
      });
    },
    //监听元素进入设备可视区域内
    listenViewInDevice() {
      let intersectionObsever = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio > 0) {
          showMore = true;
          me.getNoticeList();
        } else {
          showMore = false;
        }
      });
      intersectionObsever.observe(document.querySelector("#showMore"));
    },
    //跳转发送消息页面
    goMessage(receive_id, send_id) {
      let userid =JSON.parse(sessionStorage.getItem("userInfoData")).user_id;
      me.$router.push({
        path: "sendMessage",
        query: {
          receiveId: userid == receive_id ? send_id : receive_id,
          sendId: userid,
        },
      });
    },
    hasReadInfo() {
      postData('/user/read-notify',{
        type_id: 1
      }).then(res => {
        console.log(res);
      })
    }
  },
  mounted() {
    me = this;
    //me.getNoticeList();
    this.userId = JSON.parse(sessionStorage.getItem("userInfoData")).user_id;
    me.listenViewInDevice();
    me.getSystemMessage();
    me.hasReadInfo();
  },
};
</script>
<style scoped>
.page {
  width: 100%;
  height: 100vh;
  background-color: #dcdcdc;
}

.topContent {
  width: 100%;
  height: 45px;
  background-color: #892785;
  display: flex;
  color: #fff;
  font-weight: lighter;
  flex-shrink: 0;
}

.topContent > div {
  flex-grow: 1;
  width: 0;
}

.back {
  display: flex;
  align-items: center;
  margin-left: 10px;
}

.back img {
  width: 20px;
  height: 20px;
}

.title {
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.contentInfo {
  flex-grow: 1;
  overflow-y: scroll;
}

.noticeList {
  display: flex;
  width: 100%;
  height: 80px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  align-items: center;
}

.userHead {
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.userHead img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
}

.noticeTitle {
  display: flex;
  line-height: 30px;
}

.rightContent {
  width: 100%;
}

.noticeTitle > div {
  flex-grow: 1;
  width: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.noticeTitle > div:nth-child(1) {
  text-align: left;
}
.noticeTitle > div:nth-child(2) {
  text-align: right;
  padding-right: 10px;
}
.noticeWord {
  width: 250px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  line-height: 30px;
  font-weight: lighter;
  font-size: 14px;
  text-align: left;
}
#showMore {
  height: 30px;
  line-height: 30px;
  color: gray;
}
</style>